import { EstateBankingRoute } from '/@/modules/estatebanking/routes/EstateBankingRoute';
import { EstateBankingRequestOverviewRouteConfig } from '/@/modules/estatebanking/routes/EstateBankingRequestOverviewRouteConfig';

export const router = [
  EstateBankingRequestOverviewRouteConfig.factory({
    path: EstateBankingRoute.BANKING_REQUESTS.path,
    name: EstateBankingRoute.BANKING_REQUESTS.name,
    component: () => import('/@/modules/estatebanking/pages/EstateBankingRequestOverviewPage.vue')
  }).build()
];
